import * as React from 'react';
import OktaEnroll from './OktaEnroll';
import { IOktaMfaModel, IVerifyEventModel } from './Model';

interface IOktaSetupProps {
    okta: IOktaMfaModel;
    onClick: () => void;
    callback: (event: IVerifyEventModel) => void;
    enrollState: {
        isEnrollSelected: boolean;
        enrollFactor: string;
    };
}

/*
 * This component will be used during enrollment process where
 * user is shown multiple factors to enroll into. Every Factor
 * will have its setup component
 */
class OktaSetup extends React.Component<IOktaSetupProps> {
    render() {
        const { strings } = this.props.okta.oktaMfa;
        const setUpPageTitle = strings.factorEnrollmentTitle.replace('[FACTOR_NAME]', strings.oktaVerifyFactor);
        let setupPage;
        if (this.props.enrollState.isEnrollSelected) {
            setupPage = (
                <div>
                    <h3>{setUpPageTitle}</h3>
                    <OktaEnroll okta={this.props.okta} callback={this.props.callback} />
                </div>
            );
        } else {
            setupPage = (
                <div>
                    <span className="button-container">
                        <input
                            type="submit"
                            className="apmui-button apmui-button-submit apmui-button-long"
                            id="submit"
                            name="submit"
                            value={strings.oktaVerifyFactor}
                            onClick={this.props.onClick}
                        />
                    </span>
                </div>
            );
        }
        return <div>{setupPage}</div>;
    }
}

export default OktaSetup;
